import Constants from '../../../constants';

export default (state={}, action) => {
  switch (action.type) {
    case Constants.AWS_INSERT_S3_DATES:
    case Constants.AWS_SET_S3_DATES:
      return action.dates;
    case Constants.AWS_CLEAR_S3_DATES:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/aws/s3/datesReducer.js